import {
  overlaysDataSelector,
  userOverlaysDataSelector,
} from '@/redux/overlays/overlays.selectors';
import { store } from '@/redux/store';
import type { MapOverlay as PluginMapOverlay } from 'minerva-plugin-api';
import { toPluginMapOverlays } from '@/services/pluginsManager/adapters/toPluginMapOverlay';

export const getDataOverlays = (): PluginMapOverlay[] => {
  const overlays = overlaysDataSelector(store.getState());
  const userOverlays = userOverlaysDataSelector(store.getState()) || [];

  return toPluginMapOverlays([...overlays, ...userOverlays]);
};
